import { useEffect, useState } from "react";
import api from "@/lib/api";

const inputCls = "mt-1 w-full rounded-lg border border-stone-300 bg-white px-3 py-2 text-sm outline-none focus:border-ink";
const lbl = "text-[11px] font-bold uppercase tracking-widest text-stone2";

export const EMPTY_FILTERS = {
    search: "", status: "", industry: "", state: "", city: "", country: "",
    lead_source: "", rating: "", owner_id: "", created_after: "", created_before: "",
};

export function SfFilterBuilder({ kind, filters, onChange, onEnter }) {
    const [opts, setOpts] = useState({ status: [], industry: [], state: [], lead_source: [], rating: [], owners: [] });
    const f = { ...EMPTY_FILTERS, ...(filters || {}) };
    const set = (patch) => onChange({ ...f, ...patch });
    const isLead = (kind || "").includes("lead");

    useEffect(() => {
        if (!kind || kind === "csv") return;
        api.get("/campaigns/sf-filter-options", { params: { kind } })
            .then(({ data }) => setOpts(data))
            .catch(() => setOpts({ status: [], industry: [], state: [], lead_source: [], rating: [], owners: [] }));
    }, [kind]);

    const Select = ({ label, field, options, testid }) => (
        <div>
            <label className={lbl}>{label}</label>
            <select data-testid={testid} value={f[field] || ""} onChange={(e) => set({ [field]: e.target.value })} className={inputCls}>
                <option value="">Any</option>
                {options.map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
        </div>
    );

    return (
        <div className="space-y-3 rounded-xl border border-stone-200 bg-stone-50/60 p-4" data-testid="sf-filter-builder">
            <div>
                <label className={lbl}>Search (name, company, email, phone)</label>
                <input
                    data-testid="wizard-sf-search"
                    value={f.search || ""}
                    onChange={(e) => set({ search: e.target.value })}
                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); onEnter?.(); } }}
                    placeholder="Leave blank for all"
                    className={inputCls}
                />
            </div>
            <div className="grid gap-3 sm:grid-cols-2">
                {isLead && <Select label="Status" field="status" options={opts.status || []} testid="filter-status" />}
                <Select label="Industry" field="industry" options={opts.industry || []} testid="filter-industry" />
                <Select label="State" field="state" options={opts.state || []} testid="filter-state" />
                <Select label="Lead Source" field="lead_source" options={opts.lead_source || []} testid="filter-lead-source" />
                {isLead && <Select label="Rating" field="rating" options={opts.rating || []} testid="filter-rating" />}
                <div>
                    <label className={lbl}>Owner</label>
                    <select data-testid="filter-owner" value={f.owner_id || ""} onChange={(e) => set({ owner_id: e.target.value })} className={inputCls}>
                        <option value="">Any</option>
                        {(opts.owners || []).map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
                    </select>
                </div>
                <div>
                    <label className={lbl}>City</label>
                    <input data-testid="filter-city" value={f.city || ""} onChange={(e) => set({ city: e.target.value })} placeholder="Any" className={inputCls} />
                </div>
                <div>
                    <label className={lbl}>Country</label>
                    <input data-testid="filter-country" value={f.country || ""} onChange={(e) => set({ country: e.target.value })} placeholder="Any" className={inputCls} />
                </div>
                <div>
                    <label className={lbl}>Created after</label>
                    <input type="date" data-testid="filter-created-after" value={f.created_after || ""} onChange={(e) => set({ created_after: e.target.value })} className={inputCls} />
                </div>
                <div>
                    <label className={lbl}>Created before</label>
                    <input type="date" data-testid="filter-created-before" value={f.created_before || ""} onChange={(e) => set({ created_before: e.target.value })} className={inputCls} />
                </div>
            </div>
        </div>
    );
}
